import React from 'react'
import { Pill } from '../../../../ui'

const CYCLE = [null, 'mistake', 'colleague', 'experiment', 'reading']

// Custom 4-colour categorical palette: encodes the *kind* of source
// (mistake / colleague / experiment / reading), not a status. None of
// the four semantic Pill tones (neutral|info|success|danger) fit; the
// background/color are passed via Pill's `style` override on top of the
// shared chip recipe (display, padding, font, radius). See
// docs/contributor/design-language.md §13.
const STYLES = {
  mistake:    { background: '#F5C4B3', color: '#4A1B0C' },
  colleague:  { background: '#CECBF6', color: '#26215C' },
  experiment: { background: '#9FE1CB', color: '#04342C' },
  reading:    { background: '#FAC775', color: '#412402' },
}

const PILL_OVERRIDE = {
  fontSize: 9,
  fontWeight: 500,
  padding: '2px 7px',
  maxWidth: 120,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}

export function SourceChip({ value = null, onChange, disabled = false }) {
  const next = () => {
    const idx = CYCLE.indexOf(value)
    onChange(CYCLE[(idx + 1) % CYCLE.length])
  }

  if (value == null) {
    return (
      <Pill
        as="button"
        type="button"
        tone="neutral"
        onClick={() => !disabled && next()}
        disabled={disabled}
        aria-label="Add source tag"
        style={{ ...PILL_OVERRIDE, background: 'transparent', color: 'var(--color-text-faint)' }}
      >
        + source
      </Pill>
    )
  }

  return (
    <Pill
      as="button"
      type="button"
      tone="neutral"
      onClick={() => !disabled && next()}
      disabled={disabled}
      aria-label={`Source: ${value}. Click to change.`}
      style={{ ...PILL_OVERRIDE, ...STYLES[value] }}
    >
      {value}
    </Pill>
  )
}
